import { useEffect, useRef, useState } from 'react';
import { Button } from 'primereact/button';
import PoliciesTableContainer from '../../features/insurance/policies/PoliciesTableContainer';
import NewPolicyDrilldown from '../../features/insurance/policies/NewPolicyDrilldown';
import { PolicySummaryProvider } from '../../features/insurance/policies/PolicyContext';
import { useRolesAccessContext } from '../../context/RolesAccessContext';
import PolicyFilters, {
  PolicyFiltersOptions,
} from '../../features/insurance/policies/PolicyFilters';
import { FormProvider, useForm } from 'react-hook-form';
import { useCompanyContext } from '../../context/CompanyContext'; 
import FiltersMenu from '../../components/filters-menu/FiltersMenu';
import PolicyReportHeader from '../../features/insurance/policies/PolicyReportHeader';
import PolicyReport from '../../features/insurance/policies/PolicyReport';
import { Status } from '../../Interfaces/system/Generic.interfaces';
import PolicyParams from '../../features/insurance/policies/PolicyParams';
import { useSearchParams } from 'react-router-dom';

const Policy = () => {
  const { selectedCompany } = useCompanyContext();
  const prevSelectedCompanyRef = useRef<string | null>(null);
  const { rolesAcess } = useRolesAccessContext();
  const [showDrilldown, setShowDrilldown] = useState(false);
  const tableRef = useRef<HTMLDivElement | null>(null);
  const [searchParams] = useSearchParams();
  const methods = useForm<PolicyFiltersOptions>({
    defaultValues: {
      policyStatus: Status.active,
    },
  });
  const access = rolesAcess?.find((access) => access.report === 'policy');

  useEffect(() => {
    if (prevSelectedCompanyRef.current === null) {
      prevSelectedCompanyRef.current = selectedCompany?.id || null;
    } else if (prevSelectedCompanyRef.current !== selectedCompany?.id) {
      if (!searchParams.get('company')) {
        methods.reset();
      }
      prevSelectedCompanyRef.current = selectedCompany?.id || null;
    }
  }, [selectedCompany, methods, searchParams]);

  return (
    <div className="h-full flex flex-column">
      <PolicySummaryProvider>
        <FormProvider {...methods}>
          <div className="flex flex-column gap-2 mx-3 mt-6 my-4">
            {access?.editable && selectedCompany?.isActive && (
              <div className="flex flex-row gap-2 justify-content-between">
                <Button
                  onClick={() => {
                    setShowDrilldown(true);
                  }}
                  className="ml-5 h-fit buttonBackground text-white border-0 text-xl w-fit py-3 px-3 radius-10px"
                >
                  New Entry
                </Button>
                <NewPolicyDrilldown
                  visible={showDrilldown}
                  setVisible={setShowDrilldown}
                />
              </div>
            )}
          </div>
          <div className="flex flex-column  gap-2 mx-3 mt-4">
            <div className="flex flex-row gap-2 justify-content-between">
              <div className="flex w-full justify-content-between gap-2">
                <FiltersMenu>
                  <PolicyFilters />
                </FiltersMenu>
                <PolicyReport elementRef={tableRef} />
              </div>
            </div>
          </div>
          <div className="mb-3 printBackground pdfDivFitContent" ref={tableRef}>
            <PolicyReportHeader />
            <PoliciesTableContainer />
          </div>
          <PolicyParams />
        </FormProvider>
      </PolicySummaryProvider>
    </div>
  );
};

export default Policy;
